@if (visible()) {
<div id="imageViewer" class="overlay" (click)="onClose()">
  <div class="content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="onClose()">✖</button>
    <img [src]="imageUrl()" alt="Image" />
  </div>
</div>
}
